import { action, computed, observable } from 'mobx';

import { AppManager, Variables, Input } from 'core';

import {
  PaymentSpaceModel,
  PaymentSpaceApp,
  CreditCardApp,
} from 'apps/payment/app';

import {
  InitiativeCreditCardsQuery,
  ProfileCreditCardsQuery,
  AddPaymentMethodMutation,
  MakeDefaulPaymentMethodMutation,
  DeletePaymentMethodMutaton,
} from 'apps/payment/gql';

export class PaymentMethodsAppManager extends AppManager {
  static registryName = 'PaymentMethodsAppManager';
  @observable newCard = null;

  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('paymentSpace', PaymentSpaceApp);

    this.variables = new Variables({
      spaceSlug: () => this.spaceSlug,
    });

    this.variables.onChange(['spaceSlug'], this.NewCreditCardsQuery);
  }

  @action ResetNewCard = () => {
    this.newCard = new CreditCardApp(this);
  };

  @computed get loading() {
    const creditCardsQuery = this.queries.get('creditCards');
    return creditCardsQuery?.loading || !this.paymentSpace;
  }

  @action NewCreditCardsQuery = () => {
    const { spaceSlug } = this.variables;
    if (!spaceSlug) return;
    let CreditCardsQuery = null;
    if (spaceSlug[0] === '+') {
      CreditCardsQuery = InitiativeCreditCardsQuery;
    } else if (spaceSlug[0] === '@') {
      CreditCardsQuery = ProfileCreditCardsQuery;
    }
    if (!CreditCardsQuery) return;

    this.creditCardsQuery = new CreditCardsQuery(this, {
      queryKey: 'creditCards',
    });

    this.creditCardsQuery.process(
      result => (result ? PaymentSpaceModel.Load(result) : null),
      this.UpdatePaymentSpace,
    );
    this.creditCardsQuery.query();
  };

  @action UpdatePaymentSpace = paymentSpaceModel => {
    this.paymentSpace = paymentSpaceModel;
  };

  @action AddPaymentMethod = (stripeToken, options) => {
    const input = new Input({
      spaceSlug: () => this.spaceSlug,
      stripeToken: () => stripeToken,
    });
    this.paymentSpace = null;
    const mutation = AddPaymentMethodMutation.New(input, options);
    return mutation;
  };

  @action MakeDefaultPaymentMethod = (creditCard, options) => {
    const input = new Input({
      spaceSlug: () => this.spaceSlug,
      cardId: () => creditCard.id,
    });
    this.paymentSpace = null;
    const mutation = MakeDefaulPaymentMethodMutation.New(input, options);
    return mutation;
  };

  @action DeletePaymentMethod = (creditCard, options) => {
    const input = new Input({
      spaceSlug: () => this.spaceSlug,
      cardId: () => creditCard.id,
    });
    this.paymentSpace = null;
    const mutation = DeletePaymentMethodMutaton.New(input, options);
    return mutation;
  };
}
